import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import * as landingPageActions from '../actions/landing-page.actions';
import { LandingPageSelectors } from '../selectors/landing-page.selectors';
import {
  FPDetails,
  LandingPageState,
  SignInDetails,
  SignUpDetails,
} from '../state/landing-page.state';
import { UserDialogView } from 'src/app/landing-page/landing-page.modal';

@Injectable({
  providedIn: 'root',
})
export class LandingPageFacade {
  activeSignButton$ = this.selector.getActiveSignButton$;
  signInDetails$ = this.selector.getSignInDetails$;
  signUpDetails$ = this.selector.getSignUpDetails$;
  isPasswordUpdated$ = this.selector.getIsPasswordUpdated$;
  isOTPRequested$ = this.selector.isOTPRequested$;

  constructor(
    private store: Store<LandingPageState>,
    private selector: LandingPageSelectors
  ) {}

  setActiveSignButton(activeSignButton: UserDialogView): void {
    this.store.dispatch(
      landingPageActions.setActiveSignButton({ activeSignButton })
    );
  }

  signIn(signInDetails: SignInDetails): void {
    this.store.dispatch(landingPageActions.signIn({ signInDetails }));
  }

  signUp(signUpDetails: SignUpDetails): void {
    this.store.dispatch(landingPageActions.signUp({ signUpDetails }));
  }

  requestOTP(emailId: string): void {
    this.store.dispatch(landingPageActions.requestOTP({ emailId }));
  }

  resetPassword(fpDetails: FPDetails): void {
    this.store.dispatch(landingPageActions.resetPassword({ fpDetails }));
  }
}
